<template>
	<div class="badge badge-success">
		<span v-if="trial.lastDay">Last day free</span>
		<span v-else>Free for {{trial.daysLeft}} day<span v-show="!trial.oneDayLeft">s</span></span>
	</div>
</template>

<script>
import Vue from 'vue';
export default {
	name: 'TrialBadge',
	props: {
		expiry: Date
	},
	computed:{
		trial() {
			const now = new Date();
			const daysLeft = Math.round((this.expiry - now) / (1000 * 60 * 60 * 24));

			return {
				daysLeft: daysLeft,
				expiry: this.expiry,
				oneDayLeft: daysLeft === 1,
				lastDay: daysLeft === 0
			};
		}
	}
};
</script>



// WEBPACK FOOTER //
// ./src/components/TrialBadge.vue